import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useParams } from "react-router-dom";
import UserService from "../../../services/KangarooServices/UserService";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import * as Yup from "yup"; // Import Yup for formik
import RoleService from "../../../services/KangarooServices/RoleService";
import Select from "react-select";

const UserForm = ({ isOpen, toggle, selectedItem, fetchdata }) => {
  const [initialData, setInitialData] = useState({});
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [roleData, setRoleData] = useState([]);

  const fetchDetail = async () => {
    if (!selectedItem?.id) return;
    try {
      const response = await UserService.getbyId(selectedItem.id);
      setInitialData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [selectedItem?.id]);
  const fetchRole = async () => {
    try {
      const response = await RoleService.getList();
      setRoleData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchRole();
  }, []);
  const userType = [
    { id: 1, label: "Onshore" },
    { id: 2, label: "Offshore" },
    { id: 3, label: "Kampus" },
    { id: 4, label: "BID Offshore" },
    { id: 5, label: "BID Onshore" },
  ];
  const typeOptions =
    userType?.map((role) => ({
      value: role.id,
      label: role.label,
    })) || [];
  const roleOptions =
    roleData?.map((role) => ({
      value: role.id,
      label: role.name,
    })) || [];

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Email is required"),
    fullName: Yup.string().required("Full name is required"),
    phone: Yup.string()
      .matches(/^\d+$/, "Phone must be a number")
      .required("Phone number is required"),
    password: selectedItem?.id
      ? Yup.string().min(6, "Password must be at least 6 characters")
      : Yup.string()
          .min(6, "Password must be at least 6 characters")
          .required("Password is required"),
    confirmPassword: selectedItem?.id
      ? Yup.string().oneOf([Yup.ref("password")], "Passwords must match")
      : Yup.string()
          .oneOf([Yup.ref("password")], "Passwords must match")
          .required("Confirm password is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: initialData?.email || "",
      password: "",
      confirmPassword: "",
      fullName: initialData?.fullName || "",
      phone: initialData?.phone || "",
      roleId: initialData?.roleId?.[0] || "",
      userFrom: initialData?.userFrom || null,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          email: values.email,
          fullName: values.fullName,
          phone: values.phone,
          roleId: values.roleId,
          userFrom: values?.userFrom,
        };
        if (selectedItem?.id) {
          payload.id = selectedItem.id;

          // Only add password if user entered it
          if (values.password) {
            payload.password = values.password;
          }
          await UserService.update(payload);
          toast.success("User updated successfully");
        } else {
          payload.password = values.password;

          await UserService.create(payload);
          toast.success("User created successfully");
        }
        fetchdata();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data || "Something went wrong!");
      }
    },
  });

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
      setInitialData(null);
    }
  }, [isOpen]);

  // useEffect(() => {
  //   if (roleData.length && initialData?.roleId?.[0]) {
  //     const roleExists = roleData.find((r) => r.id === initialData.roleId[0]);
  //     if (roleExists) {
  //       formik.setFieldValue("roleId", initialData.roleId[0]);
  //     }
  //   }
  // }, [roleData, initialData]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>User Form</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {/* Email */}
          <FormGroup className="mb-3">
            <Label htmlFor="email">
              Email Address <span className="text-danger">*</span>
            </Label>
            <Input
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.email && !!formik.errors.email}
            />
            {formik.touched.email && formik.errors.email && (
              <FormFeedback>{formik.errors.email}</FormFeedback>
            )}
          </FormGroup>

          {/* Full Name */}
          <FormGroup className="mb-3">
            <Label htmlFor="fullName">
              Full Name <span className="text-danger">*</span>
            </Label>
            <Input
              id="fullName"
              name="fullName"
              value={formik.values.fullName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.fullName && !!formik.errors.fullName}
            />
            {formik.touched.fullName && formik.errors.fullName && (
              <FormFeedback>{formik.errors.fullName}</FormFeedback>
            )}
          </FormGroup>

          {/* Phone */}
          <FormGroup className="mb-3">
            <Label htmlFor="phone">
              Phone Number <span className="text-danger">*</span>
            </Label>
            <Input
              id="phone"
              name="phone"
              value={formik.values.phone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.phone && !!formik.errors.phone}
            />
            {formik.touched.phone && formik.errors.phone && (
              <FormFeedback>{formik.errors.phone}</FormFeedback>
            )}
          </FormGroup>
          <FormGroup>
            <Label>Roles</Label>
            <Select
              name="roleId"
              options={roleOptions}
              // react-select expects the full option object
              value={
                roleOptions.find((opt) => opt.value === formik.values.roleId) ||
                null
              }
              onChange={(selected) =>
                formik.setFieldValue("roleId", selected?.value || "")
              }
            />
          </FormGroup>
          <FormGroup>
            <Label>User Type</Label>
            <Select
              name="userFrom"
              options={typeOptions}
              // react-select expects the full option object
              value={
                typeOptions.find(
                  (opt) => opt.value === formik.values.userFrom,
                ) || null
              }
              onChange={(selected) =>
                formik.setFieldValue("userFrom", selected?.value || "")
              }
            />
          </FormGroup>

          {/* Password */}
          <FormGroup className="mb-3 position-relative">
            <Label htmlFor="password">
              Password <span className="text-danger">*</span>
            </Label>
            <div className="position-relative">
              <Input
                id="password"
                name="password"
                type={passwordShow ? "text" : "password"}
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.password && !!formik.errors.password}
                placeholder="Enter password"
                autoComplete="new-password" // ✅ IMPORTANT
              />
              <button
                type="button"
                className="btn btn-link position-absolute end-0 top-0 pt-2 text-muted"
                onClick={() => setPasswordShow(!passwordShow)}
              >
                <i className="ri-eye-fill align-middle"></i>
              </button>
              {formik.touched.password && formik.errors.password && (
                <FormFeedback>{formik.errors.password}</FormFeedback>
              )}
            </div>
          </FormGroup>

          {/* Confirm Password */}
          {!selectedItem?.id ? (
            <FormGroup className="mb-3 position-relative">
              <Label htmlFor="confirmPassword">
                Confirm Password <span className="text-danger">*</span>
              </Label>
              <div className="position-relative">
                <Input
                  id="confirmPassword"
                  name="confirmPassword"
                  type={confirmPasswordShow ? "text" : "password"}
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.confirmPassword &&
                    !!formik.errors.confirmPassword
                  }
                  placeholder="Confirm password"
                />
                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-0 pt-2 text-muted"
                  onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                >
                  <i className="ri-eye-fill align-middle"></i>
                </button>
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && (
                    <FormFeedback>{formik.errors.confirmPassword}</FormFeedback>
                  )}
              </div>
            </FormGroup>
          ) : null}

          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default UserForm;
